export type TPlayerColorVariant = 'primary' | 'accent';

export type TLayoutPlayerId = 'player1' | 'player2';

/** Matches `_game-player-colors.scss`: player1 = primary, player2 = accent. */
export function getLayoutPlayerColorVariant(
  layoutPlayerId: TLayoutPlayerId,
): TPlayerColorVariant {
  return layoutPlayerId === 'player1' ? 'primary' : 'accent';
}

/**
 * Engine slot → UI color. Aligns with in-game piece/symbol colors:
 * - board games: slot 0 (X) = primary, slot 1 (O) = accent
 * - chess: slot 0 (white) = accent, slot 1 (black) = primary
 */
export function getPlayerColorVariantByEngineSlot(
  gameSlug: string,
  engineSlot: 0 | 1,
): TPlayerColorVariant {
  if (gameSlug === 'classic-chess') {
    return engineSlot === 0 ? 'accent' : 'primary';
  }
  return engineSlot === 0 ? 'primary' : 'accent';
}
